<template>
  <div class='ExportCard cardBindingRecord'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle"
                 :searchHandleSpan="search.searchHandleSpan">
    </search-form>

    <Table :TableParam="Table">
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import { optionsDataReplace } from '@/utils'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging
  },
  data () {
    // 这里存放数据
    return {
      cardStatusObj:{
        0:'未激活',
        1:'终止',
        2:'正常',
        3:'已过期',
        4:'锁定',
        5:'失效',
      },
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },

      search: { // 搜索
        searchData: {}, // 返回的数据
        searchForm: [
          { type: 'Select', label: '卡类型：', prop: 'cardTypeId', width: '180px', options: [], props: this.$map.typeProps, placeholder: '请选择卡类型' },
          { type: 'Input', label: '卡名称：', prop: 'cardName', placeholder: '请输入卡名称' },
          { type: 'Select', label: '卡状态', prop: 'state', placeholder: '请选择卡状态', options: [{ label: '未激活', value: 0 },{ label: '终止', value: 1 },{ label: '正常', value: 2 },{ label: '已过期', value: 3 },{ label: '锁定', value: 4 },{ label: '失效', value: 5 }] },//this.$label.SendTypes
          { type: 'daterange', label: '制卡时间：', prop: 'genTime',  },
          { type: 'daterange', label: '入库时间：', prop: 'inboundTime',  },
          { type: 'daterange', label: '售卡时间：', prop: 'sellTime',  },
          { type: 'daterange', label: '绑卡时间：', prop: 'bindTime',  },
          { type: 'Select', label: '卡归属', prop: 'hasSysCardNo', placeholder: '请选择卡归属', options: [{ label: '系统内', value: 1 },{ label: '系统外', value: 2 }] },//this.$label.SendTypes
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ],
        searchHandleSpan: 4
      },

      multipleSelection: [], // 选中的
      Table: { // 表格
        defaultCheckBox: {
          show: true,
          data: false,
          handle: (v) => {
            this.searchHandleForm()
          }
        },
        primaryBtn: {
          show: true,
          html: '导出',
          handle: () => this.defaultEvent()
        },
        data: [],
        column: [
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'cardNo', label: '卡号' },
          { prop: 'cardKey', label: '卡密' },
          { prop: 'cardName', label: '卡名称' },
          { prop: 'creatTime', label: '制卡时间' },
          { prop: 'inboundDate', label: '入库时间' },
          { prop: 'sellTime', label: '售卡时间' },
          { prop: 'bindAccountName', label: '会员姓名' },
          { prop: 'bindAccount', label: '会员卡号' },
          { prop: 'bindMarket', label: '绑卡项目' },
          { prop: 'bindTime', label: '绑卡时间' },
          { prop: 'cardStatusName', label: '卡状态' },
          { prop: 'bindIp', label: '绑卡IP' },
          { prop: 'hasSuccessName', label: '绑卡是否成功' },
          { prop: 'failDescribe', label: '异常原因' },
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    searchHandleForm () {
      this.getItemList()
    },

    searchResetForm () {
      this.search.searchData = {}
    },
    // 列表
    getItemList () {
      const { pager, Table } = this
      const params = this.setParams()
      if(this.Table.defaultCheckBox.data){
        params.hasSuccess = true
      }
      this.$http.recordList(params)
        .then((res) => {
          if (res.status === 200) {
            pager.count = res.data.total
            Table.data = res.data.list.map(item=>{
              return {
                ...item,
                cardStatusName: this.cardStatusObj[item.cardStatus],
                hasSuccessName: item.hasSuccess == 1 ? '是' : '否'
              }
            })
            // this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 导出
    defaultEvent(){
      const { pager, Table } = this
      const params = this.setParams()
      if(this.Table.defaultCheckBox.data){
        params.hasSuccess = true
      }
      params.pageNum = null
      params.pageSize = null
      this.Table.data.length>0 && this.$http.recordListExport(params)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('执行成功')
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    setParams () {
      const { cardTypeId, cardName, state, genTime,  inboundTime, sellTime, bindTime, hasSysCardNo } = this.search.searchData
      const { pager } = this
      return {
        pageNum: pager.page,
        pageSize: pager.rows,
        cardTypeId,
        cardName,
        state,
        hasSysCardNo: hasSysCardNo == 1 ? true : (hasSysCardNo == 2 ? false : null) ,
        bindTimeBegin: bindTime ? bindTime[0] : null,
        bindTimeEnd: bindTime ? bindTime[1] : null,
        sellTimeBegin: sellTime ? sellTime[0] : null,
        sellTimeEnd: sellTime ? sellTime[1] : null,
        inboundTimeBegin: inboundTime ? inboundTime[0] : null,
        inboundTimeEnd: inboundTime ? inboundTime[1] : null,
        genTimeBegin: genTime ? genTime[0] : null,
        genTimeEnd: genTime ? genTime[1] : null,
      }
    },
    // 卡类型
    async getCardTypeList () {
      const res = await this.$http.getCardTypeList()
      if(res && res.status === 200) {
        optionsDataReplace('cardTypeId', this.search.searchForm, (res.data || []))
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getItemList()
    this.getCardTypeList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.cardBindingRecord{
  ::v-deep .el-date-editor{
    min-width: 225px;
    max-width: 320px;
    width: 100%;
  }
}
</style>
